import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatButtonModule, MatDialogModule, MatGridListModule, MatTooltipModule, MatIconModule, MatNativeDateModule, MatDatepickerModule, MatTableModule, MatSortModule, MatCheckboxModule, MatSlideToggleModule, MatRadioModule, MatSelect, MatSelectModule, MatTabsModule, matTabsAnimations, MatProgressSpinnerModule, MatPaginatorModule, MatProgressBarModule, MatExpansionModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { TextMaskModule } from 'angular2-text-mask';
import { CommonBoModuleModule } from '../common-bo-module/common-bo-module.module';
import { SchedulerComponent } from './scheduler/scheduler.component';
import { ServerResponseCode } from './scheduler/response.code.constants';
import { RouterModule } from '@angular/router';
import { DetailSchedulerComponent } from './scheduler/detail-scheduler/detail-scheduler.component';
import { PredefinedQueriesComponent } from './predefined-queries/predefined-queries.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { HomeAdminComponent } from './home-admin/home-admin.component';
import { PredefinedQueryResultsComponent } from './predefined-queries/predefined-query-results/predefined-query-results.component';
import { DetailUserComponent } from './manage-users/detail-user/detail-user.component';
import { SupportSujetComponent } from './support-sujet/support-sujet.component';
import { SupportSujetDetailComponent } from './support-sujet/support-sujet-detail/support-sujet-detail.component';
import { HomeSupportSujetComponent } from './support-sujet/home-support-sujet.component';
import { LockedUsersComponent } from './locked-users/locked-users.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    FlexLayoutModule,
    MatGridListModule,
    MatIconModule,
    MatTooltipModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    TextMaskModule,
    MatTabsModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatExpansionModule,
    CommonBoModuleModule,
    RouterModule
  ],
  declarations: [
    SchedulerComponent,
    DetailSchedulerComponent,
    PredefinedQueriesComponent,
    ManageUsersComponent,
    HomeAdminComponent,
    PredefinedQueryResultsComponent,
    DetailUserComponent,
    SupportSujetComponent,
    SupportSujetDetailComponent,
    HomeSupportSujetComponent,
    LockedUsersComponent
  ],
  providers: [
    ServerResponseCode
  ]
})
export class AdminModule { }
